import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import DecisionReviewPopupDetails from './DecisionReviewPopupDetails.vue'

export const DecisionReviewPopup = new PopupBuilder('Decision Review')
  .appendBody(DecisionReviewPopupDetails)
  .build()
